<template>
  <div style="height: 100%">
    <iframe
      ref="myIframe"
      src="https://eminwechat.xjzdcsyyyxzrgs.com/proxy-lab/?viewName=emin_view"
      scrolling="auto"
      frameborder="0"
      style="width: 100%; height: 100%"
    ></iframe>
  </div>
</template>
  
  <script>
export default {
  name: 'Drawer',
  components: {},
  data() {
    return {}
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {},
}
</script>
  
  <style scoped>
@import '~@assets/less/common.less';
</style>